// extracted by mini-css-extract-plugin
module.exports = {"form":"GiftcardModule_form__1qBjJ","formMain":"GiftcardModule_formMain__Ix8Ui","formSidebar":"GiftcardModule_formSidebar__k-Flw"};